import moment from 'moment';

export const getPatientAge = patient => {
  if (patient?.dateOfBirth) {
    return moment().diff(patient.dateOfBirth, 'years');
  }
  return null;
};

export const getPatientSexAtBirth = (patient, appointment) => {
  const sexAtBirth = patient?.gender || appointment?.requestData?.sexAtBirth;

  if (sexAtBirth) {
    if (['f', 'female'].includes(sexAtBirth.toLowerCase())) {
      return 'F';
    }
    if (['m', 'male'].includes(sexAtBirth.toLowerCase())) {
      return 'M';
    }
  }
  return null;
};
